import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import Swal from 'sweetalert2';
import { FormBuilder, Validators, FormControl, FormGroup, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-feedback-manager-sub',
  templateUrl: './add-feedback-manager-sub.component.html',
  styleUrls: ['./add-feedback-manager-sub.component.scss']
})
export class AddFeedbackManagerSubComponent implements OnInit {
  url_form: FormGroup;
  submitted = false;

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.url_form = this.fb.group({
      url_name: ["", [Validators.required]],
      review_link: ["", [Validators.required]],
      Whatsapp_link:["", [Validators.required]],
      sms_content: ["", [Validators.required]],
      version: ["", [Validators.required]]
    });
  }

  get url_form_v() { return this.url_form.controls; }

  add_url_and_sms_content_sub() {
    this.submitted = true;

    if(this.url_form.invalid) {
      return;
    }

    if(this.url_form.value.url_name.trim() == 'feedback' || this.url_form.value.url_name.trim() == 'feedbacks') {
      this.toastr.error('Please use another URL except feedback.');
      return;
    }

    let formData = new FormData();
    formData.append('url_name', this.url_form.value.url_name);
    formData.append('Whatsapp_link', this.url_form.value.Whatsapp_link);
    formData.append('review_link', this.url_form.value.review_link);
    formData.append('sms_content', this.url_form.value.sms_content);
    formData.append('version', this.url_form.value.version);

    this.auth.add_url_and_sms_content_sub(formData).subscribe((response: any) => {
      this.toastr.success(response.message);
      this.url_form.reset();
      this.submitted = false;
      
    }, e => {
      this.toastr.error(e.error.message);
    });

  }

}
